import { gsap } from 'gsap';

// GSAP behind one module (Foundations: Motion). Transform and opacity only, and nothing moves for
// people who ask for reduced motion: every animation sits inside a no-preference media query.

const NO_PREFERENCE = '(prefers-reduced-motion: no-preference)';

type EntranceOptions = {
  distance?: number;
  duration?: number;
  stagger?: number;
  floatPods?: boolean;
};

/** One entrance per view: [data-enter] rises in, [data-meter] fills, [data-pod] art floats. */
export function playEntrance(root: HTMLElement, options: EntranceOptions = {}): () => void {
  const { distance = 12, duration = 0.5, stagger = 0.06, floatPods = false } = options;
  const media = gsap.matchMedia();
  media.add(NO_PREFERENCE, () => {
    const entering = root.querySelectorAll('[data-enter]');
    if (entering.length > 0) {
      gsap.from(entering, { y: distance, autoAlpha: 0, duration, ease: 'power3.out', stagger });
    }
    const meters = root.querySelectorAll('[data-meter]');
    if (meters.length > 0) {
      gsap.from(meters, { scaleX: 0, duration: 0.9, ease: 'power3.out', delay: 0.2 });
    }
    const pods = root.querySelectorAll('[data-pod]');
    if (floatPods && pods.length > 0) {
      gsap.to(pods, {
        y: -6,
        duration: 2.6,
        ease: 'sine.inOut',
        yoyo: true,
        repeat: -1,
        stagger: { each: 0.3, from: 'random' },
      });
    }
  });
  return () => media.revert();
}

/** A new log line: y 6 to 0, opacity, 240 ms. */
export function revealLine(element: Element): () => void {
  const media = gsap.matchMedia();
  media.add(NO_PREFERENCE, () => {
    gsap.from(element, { y: 6, autoAlpha: 0, duration: 0.24, ease: 'power2.out' });
  });
  return () => media.revert();
}
